import { UcoastVideo } from '@/scripts/core/ucoast-video'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { SliderComponent } from '@/scripts/theme/slider-component'

type UgcVideo = {
	video: UcoastVideo
	muteButton: HTMLButtonElement
	playButton: HTMLButtonElement
}

export class UgcSlider extends SliderComponent {
	static override htmlSelector = 'ugc-slider'
	items: UgcVideo[]
	constructor() {
		super()
		this.items = this.getItems()
		this.setListeners()
	}
	getItems (): UgcVideo[] {
		return Array.from(q.rl('[data-uc-ugc-slider-item]')).map(item => {
			return {
				video: q.rs('ucoast-video', item),
				muteButton: q.rs('[data-uc-ugc-slider-mute]', item),
				playButton: q.rs('[data-uc-ugc-slider-play]', item)
			}
		})
	}
	setListeners() {
		this.items.forEach(item => {
			item.muteButton.addEventListener('click', this.toggleVideoMute.bind(this))
			item.playButton.addEventListener('click', this.toggleVideoPlay.bind(this))
			item.video.addEventListener('click', this.toggleVideoPlay.bind(this))
		})
	}
	toggleVideoPlay(event: Event) {
		event.preventDefault()
		const currentTarget = q.rct(event)
		const index = parseInt(q.ra(currentTarget, 'data-uc-ugc-slider-index'))
		const item = this.items[index]
		const status = q.ra(item.playButton, 'data-uc-ugc-slider-play')
		if (status === 'play') {
			item.video.pause()
			item.playButton.setAttribute('data-uc-ugc-slider-play', 'paused')
		} else {
			item.video.play()
			item.playButton.setAttribute('data-uc-ugc-slider-play', 'play')
			if (item.muteButton.getAttribute('data-uc-ugc-slider-mute') === 'muted-start')
			item.muteButton.click()

		}
	}
	toggleVideoMute(event: Event) {
		event.preventDefault()
		const currentTarget = q.rct(event)
		const status = q.ra(currentTarget, 'data-uc-ugc-slider-mute')
		const index = parseInt(q.ra(currentTarget, 'data-uc-ugc-slider-index'))
		const item = this.items[index]
		if (status === 'muted' || status == 'muted-start') {
			item.video.unMute()
			item.muteButton.setAttribute('data-uc-ugc-slider-mute', 'unmuted')
		} else {
			item.video.mute()
			item.muteButton.setAttribute('data-uc-ugc-slider-mute', 'muted')
		}
	}
}
